import { css, keyframes } from "styled-components";
import { Tabs, TabsControls, TabsTrigger, TabsContent } from "../../../../components/Tabs";
import { Grid } from "../../components/Grid";
const fadeInKeyframes = keyframes `
  from { opacity: 0;}
  to { opacity: 1; }
`;
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    padding-top: ${chroma.spacers.bladeEdge.top};

    /* base styles using theme object values */
    background-color: ${paletteTokens.bladebg1};
  }

  /* component style overrides */
  hr.tab-controls-divider {
    border-top: 1px solid #5f5f5f;
    margin-top: -2px;
    margin-left: ${chroma.spacers.variable.l};

    ${chroma.mediaQueries.mobileDown} {
      margin-left: 0;
    }
  }

  ${Tabs} {
    padding-top: 0;
  }

  ${TabsControls} {
    padding: ${chroma.spacers.constant.xs} ${chroma.spacers.variable.l} 0;
    display: flex;
    overflow-x: scroll; /* FYI: creates it's own scrollport and scroll context at this element */

    /* The scroll-padding-top added below was to address https://github.com/RiotGames/wwpub-riotgames.com/pull/407
    as adding overflow: scroll as seen above creates a new scrollport and scroll context
    and it ignored the global scroll-margin-top on all elements if not added here */
    scroll-padding-top: ${chroma.dimensions.riotbarHeight}; /* Necessary hack for proper scroll padding on page */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none;
    }
  }

  ${TabsTrigger} {
    ${chroma.typography.display8};
    text-align: left;
    white-space: nowrap;
    padding-bottom: 21px;
    margin: 0 32px 0 0;
    color: ${paletteTokens.ctatext1};

    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 100%;
      height: 0;
      bottom: 0;
    }

    &[data-state="active"] {
      position: relative;

      &::after {
        background-color: ${paletteTokens.accents1};
        height: 4px;
      }
    }

    ${chroma.mediaQueries.mobileDown} {
      height: 30px;
    }
  }

  ${TabsContent} {
    padding: 80px ${chroma.spacers.variable.l} ${chroma.spacers.variable.l};
    animation: ${fadeInKeyframes} 0.5s ease-in;

    ${chroma.mediaQueries.mobileDown} {
      padding-top: 40px;
    }
  }

  ${Grid} {
    .grid-header {
      display: flex;
      justify-content: left;
      align-items: flex-end;
      border-bottom: 1px solid ${paletteTokens.bladetext1_light};
      padding-bottom: 17px;

      ${chroma.mediaQueries.mobileDown} {
        justify-content: space-between;
      }
    }

    .grid-heading {
      ${chroma.typography.display7};
      padding-right: 24px;
    }

    .grid-subheading {
      ${chroma.typography.eyebrow};
      color: ${paletteTokens.bladetext1_light};
    }

    .grid-wrapper {
      display: flex;
      justify-content: flex-end;
    }

    .grid-body {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      width: 544px;
      padding-bottom: 87px;

      ${chroma.mediaQueries.mobileDown} {
        padding-bottom: 40px;
      }

      .grid-field {
        display: block;
        border-bottom: 1px solid ${paletteTokens.ctastroke1};

        .grid-field-name {
          ${chroma.typography.eyebrow};
          color: ${paletteTokens.bladetext1}d;
          padding-top: 60px;

          ${chroma.mediaQueries.mobileDown} {
            padding-top: 36px;
          }
        }

        .grid-field-value {
          ${chroma.typography.body3};
          padding: 5px 0 20px 0;
          padding-right: 12px;
          text-decoration: none;

          .grid-field-link:hover {
            color: ${chroma.components.uiBackground};

            .icon {
              background-color: ${chroma.components.uiBackground};
            }
          }
        }
      }

      .long {
        grid-column-end: span 2;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map